<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4146 3.41378C11.1007 3.72681 10.6919 3.92691 10.2521 3.98278C9.81229 4.03865 9.3664 3.94712 8.98418 3.72253L3.72265 8.98434C3.91259 9.30655 4.00838 9.67558 3.99913 10.0495C3.98987 10.4234 3.87595 10.7873 3.67031 11.0997C3.46466 11.4121 3.17553 11.6606 2.83575 11.8169C2.49597 11.9733 2.11916 12.0312 1.74812 11.9841C1.37708 11.937 1.02668 11.7868 0.736709 11.5506C0.446743 11.3143 0.228834 11.0015 0.107733 10.6476C-0.0133686 10.2937 -0.0328094 9.91294 0.0516186 9.54856C0.136047 9.18418 0.32096 8.85078 0.585356 8.58622C0.899232 8.2731 1.30809 8.07293 1.7479 8.01706C2.18771 7.96119 2.63363 8.05277 3.01582 8.27747L8.27735 3.01566C8.08741 2.69345 7.99162 2.32442 8.00087 1.9505C8.01013 1.57658 8.12404 1.21275 8.32969 0.900324C8.53534 0.587901 8.82447 0.33941 9.16425 0.183075C9.50403 0.0267399 9.88084 -0.0311741 10.2519 0.0159107C10.6229 0.0629955 10.9733 0.213192 11.2633 0.449442C11.5533 0.685691 11.7712 0.998524 11.8923 1.35241C12.0134 1.7063 12.0328 2.08706 11.9484 2.45144C11.864 2.81582 11.679 3.14922 11.4146 3.41378Z"
      fill="#A0A0A0"
    />
  </svg>
</template>

<script>
export default {
  name: "trendLine"
};
</script>
